import React, { useEffect } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import Main from './components/Main/Main';
import ServerError from './components/Errors/ServerError/ServerError';
import { useDispatch, useSelector } from 'react-redux';
import { changeTranslationMode } from './store/actions/settings';
import HomePage from './components/HomePage/HomePage';

const AuthRoute = ({ component: Component, authUser, ...rest }) => {
    return (
        <Route
            {...rest}
            render={props =>
                authUser ? (
                    <Component {...props} />
                ) : (
                    <Redirect to={{ pathname: '/home', state: { from: props.location } }} />
                )
            }
        />
    );
};

const Routes = () => {
    const dispatch = useDispatch();
    const location = useLocation();

    const { isAuthenticating, isAuthenticated } = useSelector(state => state.auth);

    useEffect(() => {
        const isTranslationMode = location.search.includes('translation-mode=on');

        if (isTranslationMode) {
            dispatch(changeTranslationMode(isTranslationMode));
        }
    }, []);

    return (
        <Switch>
            <Redirect exact from={'/'} to={'/app'} />
            {!isAuthenticating && (
                <AuthRoute path='/app' authUser={isAuthenticated} component={Main} />
            )}
            <Route path='/home' component={HomePage} />
            <Route path='/500' component={ServerError} />
        </Switch>
    );
};

export default Routes;
